import { render } from "./MarketingLandingPage.vue?vue&type=template&id=3f50597a&scoped=true"
import script from "./MarketingLandingPage.vue?vue&type=script&lang=js"
export * from "./MarketingLandingPage.vue?vue&type=script&lang=js"

import "./MarketingLandingPage.vue?vue&type=style&index=0&id=3f50597a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f50597a"]])

export default __exports__